import { sharedLocalization } from 'controls/designer/features/widgets/localization';
import { translator } from 'core/localization';

export const i18n = translator(
	{
		'General': {
			en: 'General',
			no: 'Generelt',
		},
		'Name': {
			en: 'Name',
			no: 'Navn',
		},
		'Datasource': {
			en: 'Datasource',
			no: 'Datakilde',
		},
		'Account': {
			en: 'Account',
			no: 'Konto',
		},
		'Datasource row': {
			en: 'Datasource row',
			no: 'Datakilderad',
		},
		'COLOR_COLUMN': {
			en: 'Color column',
			no: 'Fargekolonne',
		},
		'STATE_COLOR': {
			en: 'State color',
			no: 'Tilstandsfarge',
		},
		'LEFT': {
			en: 'Left',
			no: 'Venstre',
		},
		'RIGHT': {
			en: 'Right',
			no: 'Høyre',
		},
		'CENTER': {
			en: 'Center',
			no: 'Midtstilt',
		},
		'Display settings': {
			en: 'Display settings',
			no: 'Visningsinnstillinger',
		},
		'Column': {
			en: 'Column',
			no: 'Kolonne',
		},
		'Font color': {
			en: 'Font color',
			no: 'Skriftfarge',
		},
		'Scale factor': {
			en: 'Scale factor',
			no: 'Skaleringsfaktor',
		},
		'Alignment': {
			en: 'Alignment',
			no: 'Justering',
		},
		'Tile settings': {
			en: 'Tile settings',
			no: 'Flisinnstillinger',
		},
		'Background': {
			en: 'Background',
			no: 'Bakgrunn',
		},
		'Corner radius': {
			en: 'Corner radius',
			no: 'Hjørneradius',
		},
		'Mouseover': {
			en: 'Mouseover',
			no: 'Verktøytips',
		},
		'State settings': {
			en: 'State settings',
			no: 'Tilstandsinnstillinger',
		},
		'State value column': {
			en: 'State value column',
			no: 'Tilstandsverdikolonne',
		},
		'Display type': {
			en: 'Display type',
			no: 'Visningstype',
		},
		'State color column': {
			en: 'State color column',
			no: 'Tilstandsfargekolonne',
		},
		'State color': {
			en: 'State color',
			no: 'Tilstandsfarge',
		},
		'Datasource tile': {
			en: 'Datasource tile',
			no: 'Datakildeflis',
		},
		'Line width (px)': {
			en: 'Line width (px)',
			no: 'Linjebredde (px)',
		},
		'Line color': {
			en: 'Line color',
			no: 'Linjefarge',
		},
		'Select Datasource row': {
			en: 'Select datasource row',
			no: 'Velge datakilde rad',
		},
		'Select the datasource row to use as your data source. This row should contain unique values so it can act as an identifier':
			{
				en: 'Select the datasource row to use as your data source. This row should contain unique values so it can act as an identifier',
				no: 'Velg raden i datakilden du vil bruke som datagrunnlag.Denne raden bør inneholde unike verdier slik at den kan brukes som en identifikator.',
			},
		'State mode': {
			en: 'State mode',
			no: 'Tilstandsmodus',
		},
		'Position': {
			en: 'Position',
			no: 'Posisjon',
		},
		'BOTTOM': {
			en: 'Bottom',
			no: 'Bunn',
		},
		'TOP': {
			en: 'Top',
			no: 'Topp',
		},
		'BACKGROUND': {
			en: 'Background',
			no: 'Bakgrunn',
		},
		'NONE': {
			en: 'None',
			no: 'Ingen',
		},
		'LINE': {
			en: 'Line',
			no: 'Linje',
		},
		'STATE_MODE_INFO': {
			en: 'State settings: This feature allows you to select a value and define breach thresholds for it. When the value falls within a configured range, the corresponding state color is applied.\n\nState settings can be used in two ways:\nColumn highlighting: Apply the state color to a specific text or numeric column.\nTile visualization: Display the state as a color object inside the tile, with configurable width and position options',
			no: 'Tilstandsinnstillinger: Denne funksjonen lar deg velge en verdi og definere terskelgrenser for brudd. Når verdien faller innenfor et konfigurert område, får den tildelt den tilhørende tilstandsfargen.\n\nTilstandsinnstillinger kan brukes på to måter:\nKolonneutheving: Bruk tilstandsfargen på en bestemt tekst- eller tallkolonne.\nFlisvisualisering: Vis tilstanden som et fargeobjekt i flisen, med konfigurerbar bredde og posisjon.',
		},
		'DISPLAY_SETTINGS_INFO': {
			en: 'Display settings:\nConfigure how this field appears in the tile.\n\nColumn: Choose which datasource column to show.\nFont color: Color of the text (may be overridden by state settings).\nFont size: If left empty, the font size automatically scales based on the widget size and the element’s scale factor. Set a specific value if you want to override the automatic scaling.\n\nScale factor: Controls how much vertical space this element uses in the tile. Higher values take more space. If font size is empty, the text/value expands to fill available horizontal space. Example: With scale factors 8 and 2, the first element gets 80% of the tile height, the second gets 20%.\nAlignment: Sets the position of the text or value.',
			no: 'Visningsinnstillinger:\nKonfigurer hvordan dette feltet vises i flisen.\n\nKolonne: Velg hvilken datakildekolonne som skal vises.\nSkriftfarge: Fargen på teksten (kan overstyres av tilstandsinnstillinger).\nSkriftstørrelse: Hvis feltet står tomt, skaleres skriftstørrelsen automatisk basert på widgetens størrelse og elementets skaleringsfaktor. Angi en verdi hvis du vil overstyre den automatiske skaleringen.\n\nSkaleringsfaktor: Styrer hvor mye vertikal plass dette elementet bruker i flisen. Høyere verdier gir mer plass. Hvis skriftstørrelsen er tomt, vil tekst/verdi utvides for å fylle tilgjengelig horisontal plass.\nEksempel: Med skaleringsfaktorene 8 og 2 får det første elementet 80 % av flishøyden, og det andre får 20 %.\nJustering: Angir posisjonen til tekst eller verdi.',
		},
		'State size (px)': {
			en: 'State size (px)',
			no: 'Tilstandsbredde (px)',
		},
		'Font size': {
			en: 'Font size',
			no: 'Skriftstørrelse',
		},
		'Automatic': {
			en: 'Automatic',
			no: 'Automatisk',
		},
		'ROWS_WARNING_MESSAGE': {
			en: 'The number of rows is limited to {0}, while the datasource contains {1} rows in total. This limit is applied to improve performance.',
			no: 'Antall rader er begrenset til {0}, mens datakilden totalt inneholder {1} rader. Denne begrensningen er satt for å forbedre ytelsen.',
		},
	},
	sharedLocalization,
);
